import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { Key_subscriptions } from "../utils/constants";
import {getSubscriptionsByStudent  } from "../services/school/student/getSubscriptionsByStudent";

export const useGetSubscriptionsByStudentQuery = (pagedRequest?: PagedRequestType,options:any= null) => {
    return useQuery([Key_subscriptions, JSON.stringify(pagedRequest)], () => getSubscriptionsByStudent (pagedRequest),options?{...options}:{});
  };
